module.exports = __webpack_public_path__ + "620b39b6fbb606b278dd071206d439d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filtered.png
// module id = dCqj
// module chunks = 0